import { TemplateType, backgroundStep } from './constants';
import {
  addRecentBackground,
  changeBackgroundStep,
  changeTempRecentBackground,
  clearCurrentActiveCommonTemplate,
  saveCurrentActiveCommonTemplate,
  selectCategory,
  selectTemplate,
} from './actions';
import { addTempBackgroundImage, changeLogoEditingStatus, removeTempBackgroundImage } from '../main/actions';
import { changeTemplateElement, updateTextStyle } from '../text/logics';
import { logoEditingStatusEnum, sidebarTabKeyEnum } from '../utils/constants';

import { changeNextgenUiStatus } from '../nextgen/actions';
import { changeSidebarTabKey } from '../sidebar/actions';
import { checkBackgroundImageDpi } from '../canvas/logics';
import { getCurrentCanvasData } from '../canvas/selectors';
import { getCurrentImprintAreaKey } from '../main/selectors';
import { getTempRecentBackground } from './selectors';
import { isMobileOnly } from 'react-device-detect';
import { nextGenFlyoutPanelEnum } from '../nextgen/constants';
import { updateFullPreview } from '../preview/logics';

export const addBackgorundToRecent = (background) => (dispatch, getState) => {
  const state = getState();
  const allimprintAreaKeys = Object.keys(state.imprintAreaDict);
  allimprintAreaKeys.forEach((key) => {
    if (
      background.templateType === TemplateType.CUSTOM ||
      (background.templateType === TemplateType.COMMON &&
        state.templateDict[key] &&
        Object.values(state.templateDict[key])
          .flat()
          .some(
            (template) => template.categoryId === background.categoryId && template.templateId === background.templateId
          ))
    )
      dispatch(addRecentBackground({ imprintAreaKey: key, background }));
  });
};

export const addFeatureBackgroundToRecent = (specialTemplateDict) => (dispatch, getState) => {
  const state = getState();
  const allimprintAreaKeys = Object.keys(state.imprintAreaDict);
  allimprintAreaKeys.forEach((key) => {
    if (specialTemplateDict[key]) {
      const defaultTemplate = specialTemplateDict[key].find(
        (template) => template.templateType === TemplateType.DEFAULT
      );
      if (defaultTemplate) dispatch(addRecentBackground({ imprintAreaKey: key, background: defaultTemplate }));
    }
  });
};

export const tempRecentBackgroundSelected = (background) => (dispatch, getState) => {
  const state = getState();
  const tempRecentBackground = getTempRecentBackground(state);
  dispatch(changeTempRecentBackground(background));
  if (tempRecentBackground) {
    tempRecentBackground.templateType === TemplateType.CUSTOM
      ? dispatch(removeTempBackgroundImage())
      : dispatch(clearCurrentActiveCommonTemplate());
  }
  if (background.templateType === TemplateType.CUSTOM) {
    dispatch(addTempBackgroundImage(background));
  } else {
    dispatch(saveCurrentActiveCommonTemplate(background));
    dispatch(changeTemplateElement(background));
  }
};

export const applyRecentBackgroundSelected = () => (dispatch, getState) => {
  const state = getState();
  const tempRecentBackground = getTempRecentBackground(state);
  const currentImprintAreaKey = getCurrentImprintAreaKey(state);
  const currentCanvasData = getCurrentCanvasData(state);
  dispatch(changeTempRecentBackground(null));
  if (tempRecentBackground.templateType === TemplateType.CUSTOM) {
    dispatch(
      changeLogoEditingStatus({
        currentStatus: logoEditingStatusEnum.BackgroundRemoveWhite,
        isCropBackground: false,
      })
    );

    dispatch(
      changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.BackgroundRemoveWhitePanel } })
    );

    checkBackgroundImageDpi({
      dispatch,
      canvasData: currentCanvasData,
      returnStatus: logoEditingStatusEnum.BackgroundRemoveWhite,
      imageData: tempRecentBackground,
      isNewUploaded: true,
    });
  } else {
    dispatch(clearCurrentActiveCommonTemplate());
    dispatch(selectCategory(currentImprintAreaKey, tempRecentBackground.categoryId));
    dispatch(selectTemplate(currentImprintAreaKey, tempRecentBackground.categoryId, tempRecentBackground.templateId));
    dispatch(changeTemplateElement(tempRecentBackground));
    dispatch(updateFullPreview());
  }
  dispatch(changeBackgroundStep(backgroundStep.Init));
  if (isMobileOnly) dispatch(changeSidebarTabKey(sidebarTabKeyEnum.WhatsNext));
};

export const cancelRecentBackgroundSelected = (backupOriginalTextElements) => (dispatch, getState) => {
  const state = getState();
  const textElements = backupOriginalTextElements.map((text) => {
    return { ...text };
  });
  const tempRecentBackground = getTempRecentBackground(state);
  dispatch(changeTempRecentBackground(null));
  dispatch(updateTextStyle(textElements));
  tempRecentBackground.templateType === TemplateType.CUSTOM
    ? dispatch(removeTempBackgroundImage())
    : dispatch(clearCurrentActiveCommonTemplate());
  dispatch(changeBackgroundStep(backgroundStep.Init));
  if (isMobileOnly) dispatch(changeSidebarTabKey(sidebarTabKeyEnum.WhatsNext));
};
